export enum VideoScreensEnum {
	PREVIEW = 'preview',
	PLAY = 'play',
	PAUSED = 'pause',
	ENDED = 'end',
	FORM = 'form',
}
